module.exports = __webpack_public_path__ + "/images/ico-search-light.9466093.svg";